import React from "react";

const NotFoundPage = () => (
  <>
    <h1>Not Found 404</h1>
  </>
);
export default NotFoundPage;